import React, { useEffect, useRef, useState } from 'react';

const PhotoCapture = ({ onPhotoTaken, isProcessing, onClose, mode = 'analyze' }) => {
  const [stream, setStream] = useState(null);
  const [photo, setPhoto] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    startCamera();
    return () => {
      stopCamera();
    };
  }, []);

  const startCamera = async () => {
    try {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'environment',
          width: isMobile ? { ideal: 640, max: 1280 } : { ideal: 1280 },
          height: isMobile ? { ideal: 480, max: 720 } : { ideal: 720 },
        },
      });
      setStream(mediaStream);
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
      }
    } catch (error) {
      console.error('Camera access failed:', error);
      alert('Camera access denied. Please allow camera permissions and try again.');
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }
  };

  const takePhoto = () => {
    if (!videoRef.current || !canvasRef.current) return;
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const photoData = canvas.toDataURL('image/jpeg', 0.8);
    setPhoto(photoData);
  };

  const retakePhoto = () => setPhoto(null);

  const confirmPhoto = () => {
    if (photo) onPhotoTaken(photo);
  };

  const handleClose = () => {
    stopCamera();
    onClose();
  };

  return (
    <div className="photo-capture">
      {!photo ? (
        <div className="camera-view">
          <video ref={videoRef} autoPlay playsInline />
          <div className="camera-controls">
            <button onClick={takePhoto} disabled={isProcessing} className="primary">
              {mode === 'analyze' ? 'Take photo to analyze' : 'Take photo'}
            </button>
            <button onClick={handleClose} disabled={isProcessing} className="secondary">Close</button>
          </div>
        </div>
      ) : (
        <div className="photo-preview">
          <canvas ref={canvasRef} style={{ display: 'none' }} />
          <img src={photo} alt="Captured" />
          <div className="camera-controls">
            <button onClick={retakePhoto} disabled={isProcessing} className="secondary">Retake</button>
            <button onClick={confirmPhoto} disabled={isProcessing} className="primary">
              {mode === 'analyze' ? 'Analyze' : 'Attach'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhotoCapture;


